import { render, staticRenderFns } from "./OilTempTable.vue?vue&type=template&id=68c98995"
import script from "./OilTempTable.vue?vue&type=script&lang=js"
export * from "./OilTempTable.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OilTempTable.vue?vue&type=style&index=1&id=68c98995&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports